import React, { Fragment, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Row, Col, Nav, Tab, Dropdown, Modal } from "react-bootstrap";
import Card from "../../Card";
import { FiUser, FiCalendar, FiMoreVertical, FiPlus } from "react-icons/fi";
import AddHostelComponent from "./hostel-add-compo";
import MasterActions from "../../../views/dashboard/widget/MasterActions";
import HostelFacilitiesTable from "./hostel-facilities-table";
import {
  addHostel,
  getHostelDetails,
  deleteHostel,
  updateHostel,
} from "../../../services/OrganisationServices/hostelManagmentService";
import {
  useSharedState,
  useGlobalState,
} from "../../../services/hostelConst.js";
import HostelUsersTable from "./hostel-users-table";
import RoomsTable from "./rooms-table";
import { openModal } from "../../../services/redux/reducers/modalSlice";
import { useDispatch } from "react-redux";
import { getMethods } from "../../../services/utilityFunctions";

const HostelDetailsPage = () => {
  const dispatch = useDispatch();
  const [showAddHostelModal, setShowAddHostelModal] = useState(false);
  const [methods, setMethods] = useState({});
  const [sharedState, setSharedState] = useSharedState();
  var { id } = useParams();
  const hostelId = id;
  const parms = useParams();
  
  const handleAddHostel = () => {
    setShowAddHostelModal(true);
  };

  const { hostelMenuState, toggleHostelMenu } = useGlobalState();
  const [hostelDetails, setHostelDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [createdBy, setCreatedBy] = useState("loading...");
  const [createdOn, setCreatedOn] = useState("loading...");
  const [modifiedBy, setModifiedBy] = useState("loading...");
  const [activeKey, setActiveKey] = useState("first");
  
  useEffect(() => {
    setSharedState(true);
    toggleHostelMenu(true);
    const fetchHostelDetails = async () => {
      try {
        const response = await getHostelDetails(id);
        if (response.status === "success") {
          console.log("Hostel details:", response.data);
          setCreatedBy(response.data["CREATED BY"]);
          setCreatedOn(response.data["CREATED ON"]);
          setModifiedBy(response.data["MODIFIED BY"]);
          setHostelDetails(response.data);
          
          // Initialize methods and dispatching hostelId to Redux store
          setMethods(getMethods("Hostel", "Hostel")); 
          dispatch(openModal({ data: response.data, hostelId: id }));
        }
      } catch (error) {
        console.error("Error fetching hostel details:", error);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchHostelDetails();
    }
  }, []);

  return (
    <Fragment>
      <Tab.Container activeKey={activeKey}>
        <Row>
          <Col lg="12">
            <Card>
              <Card.Body>
                <div className="row g-3">
                  <div className="col-9">
                    <div className="mb-4">
                      <h4 className="me-2 h4 mb-0">
                        {loading
                          ? "Loading..."
                          : hostelDetails?.NAME || "Hostel Details"}
                      </h4>
                    </div>
                    <div style={{ marginBottom: "6rem" }}></div>
                    <div className="mt-4">
                      <Nav
                        as="ul"
                        className="nav-tabs mb-0 text-center profile-tab"
                        data-toggle="slider-tab"
                        id="profile-pills-tab"
                        role="tablist"
                      >
                        <Nav.Item
                          as="li"
                          className="me-3"
                          onClick={() => setActiveKey("first")}
                        >
                          <Nav.Link eventKey="first">Rooms</Nav.Link>
                        </Nav.Item>
                        <Nav.Item
                          as="li"
                          className="me-3"
                          onClick={() => setActiveKey("third")}
                        >
                          <Nav.Link eventKey="third">Users</Nav.Link>
                        </Nav.Item>
                        <Nav.Item
                          as="li"
                          className="me-3"
                          onClick={() => setActiveKey("fifth")}
                        >
                          <Nav.Link eventKey="fifth">Facilities</Nav.Link>
                        </Nav.Item>
                      </Nav>
                    </div>
                  </div>

                  <div className="col-3">
                    <div className="d-flex flex-column">
                      <div className="d-flex align-items-center p-1  hover-bg-light rounded-2 small">
                        <div
                          className="bg-light rounded-circle p-1 me-2 d-flex align-items-center justify-content-center"
                          style={{ width: 28, height: 28 }}
                        >
                          <FiUser className="text-primary fs-6" />
                        </div>
                        <div>
                          <small className="text-muted d-block">
                            Created By
                          </small>
                          <div
                            className="text-dark fw-medium"
                            style={{ fontSize: "0.875rem" }}
                          >
                            {createdBy}
                          </div>
                        </div>
                      </div>

                      <div className="d-flex align-items-center p-1 hover-bg-light rounded-2 small">
                        <div
                          className="bg-light rounded-circle p-1 me-2 d-flex align-items-center justify-content-center"
                          style={{ width: 28, height: 28 }}
                        >
                          <FiCalendar className="text-success fs-6" />
                        </div>
                        <div>
                          <small className="text-muted d-block">
                            Created On
                          </small>
                          <div
                            className="text-dark fw-medium"
                            style={{ fontSize: "0.875rem" }}
                          >
                            {createdOn}
                          </div>
                        </div>
                      </div>

                      <div className="d-flex align-items-center p-1  hover-bg-light rounded-2 small">
                        <div
                          className="bg-light rounded-circle p-1 me-2 d-flex align-items-center justify-content-center"
                          style={{ width: 28, height: 28 }}
                        >
                          <FiCalendar className="text-success fs-6" />
                        </div>
                        <div>
                          <small className="text-muted d-block">
                            Modified By
                          </small>
                          <div
                            className="text-dark fw-medium"
                            style={{ fontSize: "0.875rem" }}
                          >
                            {modifiedBy}
                          </div>
                        </div>
                      </div>
                      
                      {/* REPLACE THIS SECTION WITH MASTERACTIONS */}
                      <div className="d-flex align-items-center p-1 hover-bg-light rounded-2 small">
                        <div
                          className="bg-light rounded-circle p-1 me-2 d-flex align-items-center justify-content-center"
                          style={{ width: 28, height: 28 }}
                        >
                          <MasterActions
                            actions={{
                              edit: true,
                              delete: true,
                              status: true,
                              addHostel: true
                            }}
                            methods={methods}
                            refresh={() => {
                              // Re-fetch hostel details  
                              const fetchHostelDetails = async () => {
                                try {
                                  const response = await getHostelDetails(id);
                                  if (response.status === "success") {
                                    setCreatedBy(response.data["CREATED BY"]);
                                    setCreatedOn(response.data["CREATED ON"]);
                                    setModifiedBy(response.data["MODIFIED BY"]);
                                    setHostelDetails(response.data);
                                  }
                                } catch (error) {
                                  console.error("Error fetching hostel details:", error);
                                }
                              };
                              
                              fetchHostelDetails();
                            }}
                            deleteRow={deleteHostel}
                            updateRow={updateHostel}
                            isDetailsPage={true}
                            item={hostelDetails || {}}
                            title="Hostel"
                          />
                        </div>
                        <div>
                          <div
                            className="text-dark fw-medium"
                            style={{ fontSize: "0.875rem" }}
                          >
                            Show Options
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col lg="12">
            <Tab.Content className="profile-content">
              <Tab.Pane eventKey="first" id="profile-feed">
                <RoomsTable />
              </Tab.Pane>

              <Tab.Pane eventKey="third" id="profile-friends">
                <HostelUsersTable hostelId={id} />
              </Tab.Pane>

              <Tab.Pane eventKey="fifth" id="profile-friends">
                <HostelFacilitiesTable hostelId={id} />
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
      <Modal
        show={showAddHostelModal}
        onHide={() => setShowAddHostelModal(false)}
        size="lg"
        scrollable={true}
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-primary">Add Hostel</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AddHostelComponent />
        </Modal.Body>
      </Modal>
    </Fragment>
  );
};

export default HostelDetailsPage;